import * as React from 'react';

function Spinner() {
    return <div className="loader" />;
}

export default Spinner;
